<template>
    <v-card class="my-2 product-card" :class="{pointer: comparisonMode}" variant="outlined" :hover="comparisonMode">
        <component
            :is="comparisonMode || isPackage || isAddOn ? 'span' : 'nuxt-link'"
            no-prefetch
            :to="productLink"
            class="text-h6 text-decoration-none"
        >
            <v-img
                class="text-white align-end"
                height="200"
                cover
                :src="$filters.imageUrl(thumb, 600)"
                :alt="name"
                :lazy-src="$filters.srcHost('/placeholder.png')"
                @error="imgError = true"
            >
                <template v-slot:placeholder>
                    <v-row v-show="!imgError && thumb" class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey-lighten-5" />
                    </v-row>
                </template>
                <v-card-title class="text-subtitle-1">
                    <slot name="cardTitle">
                        {{ name }}
                    </slot>
                </v-card-title>
            </v-img>
            <slot name="wishlist" />
            <recommended-icon v-if="isRecommended" class="recommended-thumb" />
        </component>
        <div class="mx-4">
            <slot />
            <div class="d-flex justify-space-between mt-3">
                <slot name="price" />
                <v-btn v-if="!isAddOn" class="product-card__book" variant="flat" color="primary" :to="productLink">
                    {{ $t('book') }}
                </v-btn>
            </div>
        </div>
        <v-expand-transition>
            <div v-if="expandedCount" class="mt-3">
                <slot name="offers" />
            </div>
        </v-expand-transition>
        <div v-if="offersCount > expandedCount && expandedCount !== 0" class="d-flex my-4 justify-center">
            <v-btn variant="flat" size="small" color="primary" @click.stop="showMore">
                {{ $t('show_more') }}
            </v-btn>
        </div>
        <v-btn block variant="flat" class="mt-3" data-cy="product-card-toggle-offers" @click="toggleOffers">
            {{ expandedCount ? $t('hide') : $t('show') }}
            <v-icon>mdi-chevron-{{ expandedCount ? 'up' : 'down' }}</v-icon>
        </v-btn>
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import {ProductCardLayout} from '~/components/search/ProductCardLayout.vue'
    import RecommendedIcon from '@/components/search/RecommendedIcon.vue'

    @Component({
        components: {RecommendedIcon},
    })
    export class ProductCardLayoutMobile extends ProductCardLayout {
        @Prop({default: false, type: Boolean}) isPackage
        @Prop({default: false, type: Boolean}) isAddOn

        showMore() {
            this.expandedCount = this.expandedCount + 5 > this.offersCount ? this.offersCount : this.expandedCount + 5
        }
    }

    export default ProductCardLayoutMobile
</script>

<style scoped lang="scss">
    .product-card {
        border: none !important;
    }

    .v-card-title {
        background: rgba(0, 0, 0, 0.5);
        white-space: normal;

        a {
            color: #ffffff;
            text-decoration: none;
        }
    }

    .break-word {
        word-break: break-word;
    }

    :deep(.v-expansion-panel) {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .recommended-thumb {
        position: absolute;
        top: 0;
        left: 0;
        width: 50px;
        height: 50px;
    }
</style>
